import React, { useEffect, useState } from 'react';
import Card, { CardContent } from '../../../components/ui/Card';
import Button from '../../../components/ui/Button';
import { paymentsService } from '../../../services/paymentsService';
import { CreditCardIcon } from '@heroicons/react/24/outline';

const PaymentMethodsPage: React.FC = () => {
  const [methods, setMethods] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [billingPortalLoading, setBillingPortalLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await paymentsService.getPaymentMethods();
      setMethods(res.paymentMethods || []);
    } catch (error) {
      console.error('Failed to load payment methods:', error);
      setMethods([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const handleManagePaymentMethods = async () => {
    setBillingPortalLoading(true);
    try {
      const response = await paymentsService.createBillingPortalSession();
      // Redirect to Stripe Billing Portal
      window.location.href = response.url;
    } catch (error: any) {
      alert(error.response?.data?.message || 'Failed to open billing portal');
      setBillingPortalLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Payment Methods</h1>
        <Button 
          onClick={handleManagePaymentMethods}
          disabled={billingPortalLoading}
        >
          <CreditCardIcon className="w-5 h-5 mr-2" />
          {billingPortalLoading ? 'Loading...' : 'Manage Payment Methods'}
        </Button>
      </div>
      <Card>
        <CardContent className="p-6">
          {loading ? (
            <div>Loading…</div>
          ) : methods.length === 0 ? (
            <div className="text-center py-8 text-gray-600">No saved payment methods yet.</div>
          ) : (
            <div className="space-y-3">
              {methods.map((m) => (
                <div key={m.id} className="flex items-center justify-between p-3 border rounded">
                  <div>
                    <div className="font-medium text-gray-900">{m.method}</div>
                    <div className="text-sm text-gray-500">{m.processor} • Last used {new Date(m.lastUsed).toLocaleDateString()}</div>
                  </div>
                  <Button size="sm" variant="outline">Manage</Button>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentMethodsPage;

